import { render, staticRenderFns } from "./enrichmentConnection.vue?vue&type=template&id=2e1b4f20&scoped=true&"
import script from "./enrichmentConnection.vue?vue&type=script&lang=js&"
export * from "./enrichmentConnection.vue?vue&type=script&lang=js&"
import style0 from "./enrichmentConnection.vue?vue&type=style&index=0&id=2e1b4f20&scoped=true&lang=css&"
import style1 from "./enrichmentConnection.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1b4f20",
  null
  
)

export default component.exports